module.exports = __webpack_public_path__ + "img/zdtg@2x.09f757df.png";